var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { processRequestConfig, processResponseConfig } from '@byted/uc-secure-crypto';
import { processQuery } from '../utils';
import { get } from '../utils/data';
import { pathListKey } from '../utils/constant';
/**
 * 获取当前请求配置
 * @param xhrConfig request config
 * @returns needProxy & proxyConfig  needProxy表示是否需要代理  proxyConfig 代理配置
 */
export var getHooksConfig = function (xhrConfig) {
    var list = get(pathListKey);
    var url = xhrConfig.url;
    var needProxy = false;
    var proxyConfig = null;
    if (!list || !Array.isArray(list)) {
        return { needProxy: false, proxyConfig: null };
    }
    for (var ind = 0; ind < list.length; ind++) {
        if (needProxy && proxyConfig) {
            break;
        }
        var element = list[ind];
        var proxy = element.proxy, _a = element.proxyPathList, proxyPathList = _a === void 0 ? [] : _a;
        if (typeof proxy === 'boolean' && proxy) {
            for (var index = 0; index < proxyPathList.length; index++) {
                var ele = proxyPathList[index];
                var reg = new RegExp(ele);
                if (url.match(reg)) {
                    needProxy = true;
                    proxyConfig = element;
                    break;
                }
            }
        }
        else if (typeof proxy === 'function') {
            var res = proxy(xhrConfig);
            if (res) {
                needProxy = true;
                proxyConfig = element;
                break;
            }
        }
    }
    return { needProxy: needProxy, proxyConfig: proxyConfig };
};
/**
 * 处理请求配置
 * @param requestConfig 请求配置
 * @param packageJson sdk版本号
 * @returns request config
 */
export var processProxyRequestConfig = function (requestConfig, packageJson) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, needProxy, proxyConfig, crypt, _b, _c, signDataType, requestMiddleware, responseDataType, signDataKey, _d, certType, res, newUrl;
    return __generator(this, function (_e) {
        _a = getHooksConfig(requestConfig), needProxy = _a.needProxy, proxyConfig = _a.proxyConfig;
        crypt = (proxyConfig || {}).crypt;
        if (needProxy && crypt) {
            _b = proxyConfig || {}, _c = _b.signDataType, signDataType = _c === void 0 ? 'header' : _c, requestMiddleware = _b.requestMiddleware, responseDataType = _b.responseDataType, signDataKey = _b.signDataKey, _d = _b.certType, certType = _d === void 0 ? 'header' : _d;
            if (requestMiddleware) {
                res = requestMiddleware(requestConfig, crypt);
                newUrl = processQuery(res.url, (res === null || res === void 0 ? void 0 : res.params) || {});
                return [2 /*return*/, { url: newUrl, body: res === null || res === void 0 ? void 0 : res.body, headers: res === null || res === void 0 ? void 0 : res.headers, method: res === null || res === void 0 ? void 0 : res.method, params: res === null || res === void 0 ? void 0 : res.params }];
            }
            return [2 /*return*/, processRequestConfig(requestConfig, crypt, packageJson, signDataType, certType)];
        }
        return [2 /*return*/, requestConfig];
    });
}); };
/**
 * 处理请求回参
 * @param response response config
 * @returns response config
 */
export var processProxyResponseConfig = function (response) {
    var _a = getHooksConfig(response === null || response === void 0 ? void 0 : response.config), needProxy = _a.needProxy, proxyConfig = _a.proxyConfig;
    var _b = proxyConfig || {}, responseMiddleware = _b.responseMiddleware, crypt = _b.crypt;
    if (needProxy && crypt) {
        if (responseMiddleware) {
            var responseData = responseMiddleware(response, crypt);
            response.headers = responseData === null || responseData === void 0 ? void 0 : responseData.headers;
            response.response = responseData === null || responseData === void 0 ? void 0 : responseData.response;
        }
        else {
            return processResponseConfig(response, crypt);
        }
    }
    return response;
};
